export default {"src":"/_next/static/media/grammarBg.9ce89895.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};